<script>
  import { createEventDispatcher } from "svelte"
  const dispatch = createEventDispatcher()
  import notify from "../../../../Script/notify"
  import { checkValidDate } from "../../../Publish/SinglePublish/script"
  import ApplicationState from "../../../../Stores/applicationStates"

  /**
   * @type {Boolean} whether to show passcode enter area are not
   */
  let toggleBtn = false

  /**
   * @type {String} to store the expiry date
   */
  let dateInput = ""

  /**
   * @type {notificationExpired}
   */
  let notificationExpired = {
    close() {},
  }

  /**
   * @description Function dispatch the expiry date
   */
  const enterDate = async (e) => {
    notificationExpired.close()
    let dispatchValue = ""
    try {
      if (!dateInput) return
      await checkValidDate(e)
      dispatchValue = new Date(dateInput).toISOString()
      dispatch("output", dispatchValue)
    } catch (error) {
      console.error(error)
      dateInput = ""
      const info = "PAGE: Secure Access\nEVENT: While changing expiry date."
      notificationExpired = notify.danger(error, info)
    }
  }
</script>

<div class="group space-y-3">
  <button on:click={() => (toggleBtn = !toggleBtn)} style="color-scheme: {$ApplicationState.darkMode ? 'dark' : ''}" class="flex w-full items-center justify-between {dateInput ? 'bg-green-500' : toggleBtn ? 'bg-[#09f6e7]/50' : 'bg-slate-200  hover:bg-[#09f6e7]/50  dark:bg-[#212539] dark:hover:bg-[#09f6e7]/50'} rounded-md px-3 py-2 text-[#292a23] dark:text-[#09f6e7] sm:px-6 sm:py-4">
    <div class="flex select-none {dateInput || toggleBtn ? 'text-white' : ''} items-center gap-3 text-sm font-semibold group-hover:text-white mobile:text-base">
      <i class="fa-solid fa-calendar-days hidden mobile:block" />
      <p>Secure by Expiry</p>
    </div>
    <div class="flex items-center gap-3">
      {#if dateInput}
        <div class="text-base text-white mobile:right-14 mobile:text-2xl">
          <i class="fa-solid fa-shield-check" />
        </div>
      {:else}
        <div class="text-base {toggleBtn ? 'text-white' : 'text-[#292a2f] dark:text-[#09f6e7]'} group-hover:text-white mobile:right-14 mobile:text-2xl">
          <i class="fa-solid fa-shield-exclamation" />
        </div>
      {/if}
      <!-- <ToggleSwitch bind:toggleBtn disable={dateInput} /> -->
    </div>
  </button>
  {#if toggleBtn}
    <div class="space-y-3 rounded-md p-3 shadow-md dark:bg-bodyblack mobile:p-6">
      <p class="select-none text-gray-800 dark:text-gray-200">Here you can give expiration date for your URL.</p>
      <div class="flex flex-col gap-1 sm:flex-row sm:items-center sm:gap-6">
        <p class="w-full select-none text-sm text-gray-200 sm:w-4/12 sm:text-base">URL Expiration</p>
        <div class="flex w-full items-center gap-3">
          <div class="relative w-full sm:w-2/3">
            <input on:change={enterDate} bind:value={dateInput} placeholder="31-05-2024" type="date" id="dateInput" name="passcode" style="color-scheme: {$ApplicationState.darkMode ? 'dark' : 'light'} ;" class="z-20 h-[37.6px] w-full rounded-md border border-[#a0a1a580] bg-transparent px-3 pl-5 text-sm text-gray-800 outline-none placeholder:font-normal placeholder:text-gray-200 invalid:animate-shake invalid:border-red-500 invalid:placeholder-red-500 focus:border-blue-500 focus:ring-1 focus:ring-blue-500 focus:invalid:border-red-500 focus:invalid:ring-red-500 dark:text-white sm:text-sm" />
            <button type="submit" class="absolute right-3 top-2 z-10 text-gray-800 dark:text-slate-200">
              <i class="fa-solid fa-calendar-days" />
            </button>
          </div>
        </div>
      </div>
    </div>
  {/if}
</div>

<style>
  input#dateInput {
    position: relative;
  }

  input[type="date"]::-webkit-calendar-picker-indicator {
    background: transparent;
    bottom: 0;
    cursor: pointer;
    height: auto;
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
    width: auto;
  }
</style>
